export default __webpack_public_path__ + "static/media/cari_produk.4d71b149.svg";